export default __webpack_public_path__ + "f53321db1d08c34b3e02ebf27043733b.svg";